import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";

// Pages
import HomePage from "./pages/HomePage";
import ChefApplicationPage from "./pages/ChefApplicationPage";
import RestaurantRequestPage from "./pages/RestaurantRequestPage";
import AboutPage from "./pages/AboutPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/per-pizzaioli" element={<ChefApplicationPage />} />
              <Route path="/per-ristoratori" element={<RestaurantRequestPage />} />
              <Route path="/chi-siamo" element={<AboutPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/termini-servizio" element={<TermsPage />} />
              <Route path="/admin" element={<AdminLoginPage />} />
              <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster 
            position="top-right" 
            toastOptions={{
              style: {
                background: 'hsl(224 48% 16%)',
                color: 'hsl(34 54% 89%)',
                border: '1px solid rgba(212, 175, 55, 0.2)',
              },
            }}
          />
        </div>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
